/* ----------------------------------------------------------------------------------------
  AlisanWebsite Frontend JS.
  Jul 2022
  Inan Olcer Kozmoz
  v.1.0.0
----------------------------------------------------------------------------------------*/
// Libs
import { gsap } from "gsap";
// import Tween from 'gsap';

// import { ScrollToPlugin } from 'gsap/all';
// import { ScrollTrigger } from 'gsap/all';

// import SVGInject from '@iconfu/svg-inject';
import MouseFollower from "mouse-follower";

// Photo Swipe
import PhotoSwipeLightbox from './photoswipe-lightbox.esm.js';
 import PhotoSwipe from './photoswipe.esm.js';

import 'photoswipe/style.css';

import "../sass/main.scss";

import imagesLoaded from "imagesLoaded";

// Kozmoz App Modules
import Utils from "./kozmoz-utils";
// import HeroSlider from './hero-slider';
// import HomeSlider from './home-slider';
import NoteSlider from "./note-slider";
// import FullpageMenu from './fullpage-menu';
import ContactForm from "./contact-form";

import SubscribeForm from "./subscribe-form";
// import { set } from 'animejs';

class App {
  constructor(settings) {
    // console.log("App.constructor", this);

    // App Variables
    let gui = {};
    this.currentPage = "home";
    let heroSlider = null;
    // Default settings
    let defaults = {
      name: "Alisan Group Website",
      // selector   : '#app',
      debug: false,
      theme: "dark",
    };

    this.config = Object.assign({}, defaults, settings);
    // app.log( `Hello ${this.config.name} `);
    // this.init();
  }

  init() {
    // app.log( `Init ${name} `);
    app.log(`App.init ${this.config.name} `);
    addEventListener("DOMContentLoaded", this.initGUI.bind(app, this));

    // Key listener fo modal ESC close
    document.addEventListener("keydown", this.onKeyDown.bind(this));
    window.addEventListener("resize", this.onWinReszie.bind(this));
    window.addEventListener("scroll", this.onScroll.bind(this));
    // window.addEventListener('mousemove', this.onMouseMove.bind(this));
    // Key listener
    //
  }

  initGUI(app, e) {
    // app.log("Protocol:" + window.location.protocol)
    let path = window.location.pathname;
    this.currentPath = path.split("/");
    this.currentPage = path.split("/").pop();
    app.log("App.DOMLoaded:", app);
    app.log("App.initGUI:", app);
    // app.log("Event:",e)
    app.log("App.currentPage:", this.currentPage);
    app.log("App.currenpath:", this.currentPath);
    // GUI ELEMENTS
    this.gui = {
      main: document.querySelector("#main"),
      hamburger: document.querySelector("#hamburger"),
      hamburger_open: document.querySelector("#h_open"),
      hamburger_close: document.querySelector("#h_close"),
      // loading     : document.querySelector('#loading'),
      bg_overlay: document.querySelector("#bg_overlay"),
      header: document.querySelector("#header_container"),
      logo: document.querySelector("#logo"),
      main: document.querySelector("#main"),
      fullpage_nav: document.querySelector("#navigation"),
      menu_left: document.querySelector("#left-container"),
      menu_right: document.querySelector("#right-container"),
      top_nav: document.querySelector("#top-nav"),
      progress: document.querySelector("#progress"),
      sineWaves: document.querySelectorAll(".sineWave"),
      contact_container: document.querySelector(".footer-contact"),
      contact_form: document.querySelector("#footer_contact"),
      contact_fullname: document.querySelector("[name=fullname]"),
      contact_email: document.querySelector("[name=email]"),
      contact_subject: document.querySelector("[name=subject]"),
      // nav_current     : document.querySelector('#nav_current'),
    };
    app.log("dom.gui", this.gui);

    // Init GUI -- |
    // app.injectSVGs();
    // app.fullpageMenu = new FullpageMenu(this);
    // app.fullpageMenu.init();
    // app.initHomeSlider(window.homeCaptions);
    app.initCursor();
    this.initBurgerMenu();
    
    // app.initSubscribeForm();
    
    if (app.currentPath[1] === "haberler") {
      // Haber detay
      app.initProjectsGallery();
    } 
    
    if (app.currentPage === "iletisim") {
      app.contactForm = new ContactForm(this, "contact_form");
    } else if (app.currentPage === "home") {
    }

    app.initNoteSlider();

    // let foot = new p5(sineWaves,document.getElementById('sine_footer')); // invoke p5
    setTimeout(function () {
      // app.initSineWaves();
    }, 1000);
  }

  initSubscribeForm() {
    app.subscribeForm = new SubscribeForm(this, "subscribe_form");
  }

  initSineWaves() {
    app.log("initSineWaves");
    app.gui.sineWaves.forEach((item, i) => {
      let foot = new p5(sineWaves, item); // invoke p5
      // console.log(item.id)
    });
  }

  initHeroSlider(captions) {
    app.log("initHeroSlider");
    if (this.heroSlider == null || this.heroSlider == undefined) {
      this.heroSlider = new HeroSlider(this, captions, ".hero-slider");
    }
    this.heroSlider.init();
  }

  initHomeSlider(captions) {
    // app.log("initHomeSlider")
    // if (this.homeSlider == null || this.homeSlider == undefined) {
    //   this.homeSlider = new HomeSlider(this,captions,'.home-slider');
    // }
    // this.homeSlider.init();
  }

  initNoteSlider() {
    // console.log("initNoteSlider");
    if (this.noteSlider == null || this.noteSlider == undefined) {
      this.noteSlider = new NoteSlider(this);
      // // Fade In ın Page Load
      // let main = document.getElementById('main');
      // Tween.fromTo( main, {opacity:0}, {opacity:1, duration:1, delay:0 });
      // let heroTitle = document.querySelector('.hero-title');
      // app.log("heroTitle: ", heroTitle)
      // gsap.set(heroTitle, { opacity: 0 })
      // gsap.fromTo(heroTitle, 1, { x: -100, opacity: 0 }, { x: 0, opacity: 1, delay: .3 });
    }
    this.noteSlider.init();
  }

  initCursor() {
    app.log("initCursor");
    if (Utils.mobileCheck() == false) {
      MouseFollower.registerGSAP(gsap);
      const cursor = new MouseFollower({
        container: document.body,
        speed: 0.85,
        // ease : 'back',
        ease: "expo",
        // visible: false,
        // visibleOnState:true,
        className: "mf-cursor",
        // iconSvgSrc  : './assets/images/sprite.svg',
        // iconSvgClassName: 'ae-mouse-icon',
        iconSvgNamePrefix: "",
        skewing: 0,
        skewingText: 0,
        skewingIcon: 0,
        // hideOnLeave:0,
        stateDetection: {
          "-md -invert -white": "footer",
          // '-md -multiply'         : '.card a',
          "-xlg -multiply": ".topnav a",
          // '-md -invert -white'         : '.content a',
          "-md -invert -yellow": ".project-link",
          "-md -invert -yellow": ".service-link",
          "-lg -invert": "button",
          // '-md -invert -yellow'    : '.project-link', // service item
          // '-invert -md -white'    : '.link', // service item
          "-md -invert": "footer a",
          "-hidden": "input",
        },
      });
    }
  }

  // ----------------------------------------------------------------------------------------

  initBurgerMenu() {
    // console.log("initBurgerMenu");
    var burger = document.querySelector("#hamburger");
    var header = document.querySelector("#header_container");
    var open = document.querySelector("#h_close");
    var close = document.querySelector("#h_open");
    var nav = document.querySelector("#top-nav");
    var middle = header.querySelector('.middle');

    burger.addEventListener("click", function () {
      // console.log("click",burger.dataset.is_opened);
      burger.classList.toggle("is-active");
      nav.classList.toggle("is-active");
      if (burger.dataset.is_opened == "true") {
        burger.dataset.is_opened = "false";
        header.classList.remove("scroll-up");
        header.classList.add("scroll-down");
      } else {
        burger.dataset.is_opened = "true";
        // header.classList.remove("scroll-up");
        // header.classList.add("scroll-down");
      }
    });

    var controls = document.getElementsByClassName("navbar-item");
    for (var i = 0; i < controls.length; i++) {
      controls[i].addEventListener(
        "click",
        function (e) {
          //              e.preventDefault();
          burger.classList.remove("is-active");
          nav.classList.remove("is-active");
        },
        false
      );
    }

    // Nizards
    burger.addEventListener('click', function() {
      middle.classList.toggle('active');
      header.classList.toggle('scroll-down');
      open.classList.toggle('is-hidden');
      close.classList.toggle('is-hidden');
        
    });

    // id top-nav li > a on click id hamburger trigger click
    var nav = document.getElementById('top-nav');
    var navLinks = nav.querySelectorAll('li > a');
    navLinks.forEach(function(link) {
      link.addEventListener('click', function() {
        // trigger click on hamburger button
        burger.click();
      });
    });
  }
  // ----------------------------------------------------------------------------------------

  //--------------------------------------------------------------------------------

  initProjectsGallery() {
    // console.log("initProjectsGallery");
    const lightbox = new PhotoSwipeLightbox({
      gallery: "#notes-gallery",
      children: "a",
      pswpModule: PhotoSwipe,
      zoom: false,
      allowPanToNext: true,
      pinchToClose: true,
      preload: [1, 4],
      closeOnVerticalDrag: true,
      showAnimationDuration: 300,
      hideAnimationDuration: 300,
    });
    lightbox.init();
  }

  //--------------------------------------------------------------------------------
  getInTouch(el, subject = "") {
    app.log("getInTouch", el, subject);
    // pApp.gui.contact_subject.value = el.dataset.message;
    app.gui.contact_subject.value = subject;
    // pApp.gui.contact_subject.focus();
    app.gui.contact_fullname.focus();
    app.gui.contact_container.classList.add("is-focused");
    let menu = document.querySelectorAll("#top-nav li a");
    menu.forEach((item, i) => {
      item.classList.remove("is-active");
      app.log(item.innerHTML);
      if (item.innerHTML == "Contact") {
        item.classList.add("is-active");
        //app.log("----bom")
        /*let anim = gsap.timeline({paused:false});
        let rect = Utils.getOffset(item);
        let xx = item.offsetLeft-12;
        let ww = item.offsetWidth;
        app.log("active link:", item)
        app.log("active rect:", rect)
        anim.to( app.gui.nav_current, {x : xx,width:ww ,duration:0.3,delay:0,ease:"power2.inOut"} );
        */
      }
    });
    app.scrollTo("footer");
  }
  //--------------------------------------------------------------------------------

  scrollTo(elm, offset = 0) {
    //app.log("App.scrollTo:",elm);
    if (elm instanceof HTMLElement) {
      elm = elm;
    } else {
      elm = document.getElementById(elm);
    }
    // app.log(elm.offsetTop);
    elm = elm == undefined ? window : elm;
    window.scrollTo({
      top: elm.offsetTop + offset,
      left: 0,
      behavior: "smooth",
    });
    //or to scroll to the element with the ID "#someID":
    // gsap.to(window, {duration: 1, scrollTo: ( elm.offsetTop + offset) });
  }
  //--------------------------------------------------------------------------------

  onKeyDown(event) {
    event = event || window.event;
    // app.log(this);
    // app.log("Document: " + event.keyCode)
    if (event.keyCode === 27) {
      // ESC
      if (app.gui.hamburger.dataset.is_opened == "true") {
        // this.fullpageMenu.closeMenu();
      }
    }
  }
  //--------------------------------------------------------------------------------

  onWinReszie(ev) {
    app.log("onWinReszie:", ev);
    // app.log("onWinReszie:",  app.currentPath);
    if (app.currentPath[2] == "projects" || app.currentPath[2] == "home") {
    }
  }


  //--------------------------------------------------------------------------------
  // On mouse move event if mouse is in header area show header
  /*onMouseMove(event) {
    console.log("onMouseMove", event);
    const headerRect = app.gui.header.getBoundingClientRect();

    if (
      (event.clientY >= headerRect.top && event.clientY <= headerRect.bottom) ||
      window.headerIsOpening === false
    ) {
      app.gui.header.classList.add("scroll-up");
      app.gui.header.classList.remove("scroll-down");
      window.headerIsOpening = true;
    } else {
      app.gui.header.classList.remove("scroll-up");
      app.gui.header.classList.add("scroll-down");
      window.headerIsOpening = true;
    }
    setTimeout(() => {
      window.headerIsOpening = false;
    }, 500);
  }*/
  //--------------------------------------------------------------------------------

  onScroll(e) {
    const scrollUp = "scroll-up";
    const scrollDown = "scroll-down";
    let currentScroll = window.scrollY;
    let _lastScroll = window.lastScroll || 0;
    // let header = document.querySelector('header');
    // var percent = window.scrollY / (document.body.offsetHeight - window.innerHeight); // 0 ile 1 arasında degerler.

    // console.log("currentScroll:", currentScroll);
    // console.log("lastScroll:", _lastScroll);
    // determine current state up or down
    let scrollState = currentScroll > _lastScroll ? scrollDown : scrollUp;
    window.lastScroll = currentScroll;
    // console.log("scrollState:", scrollState);
    // console.log("app.gui.header:",app.gui.header);
    
    
    // onnly work on desktop and larger screeens 
    
    if (lastScroll > 150) {
      if (scrollState == "scroll-down") {
        app.gui.header.classList.remove(scrollUp);
        app.gui.header.classList.add(scrollDown);
      } else {
        app.gui.header.classList.remove(scrollDown);
        app.gui.header.classList.add(scrollUp);
      }
    }


  }

  //------------------------------------------------------------------------------
  log() {
    if (this.config.debug === true) {
      let str = "";
      console.log(arguments);

      // console.log( str );
    }
  }
}

export default App;

let settings = { selector: "#app", name: "Website" };
window.app = new App(settings);
window.app.init();
